import type { ModulePermissionShape } from "@/types/permissions";

export const contractorVisitPermissionKeys = [
  "contractor_visits_read_basic",
  "contractor_visits_read_full",
] as const;

export type ContractorVisitPermissions = ModulePermissionShape<
  typeof contractorVisitPermissionKeys
>;
